"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DirectBook;
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _react = _interopRequireWildcard(require("react"));
var _xstate = require("xstate");
var _propTypes = require("prop-types");
var _framerMotion = require("framer-motion");
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _States = require("../../lib/constants/States");
var _steps = _interopRequireDefault(require("../../lib/constants/steps"));
var _ApptInfo = _interopRequireDefault(require("../ApptInfo"));
var _ApptTime = _interopRequireDefault(require("../ApptTime"));
var _PatientInfo = _interopRequireDefault(require("../PatientInfo"));
var _ReviewAppt = _interopRequireDefault(require("../ReviewAppt"));
var _Loading = require("../Loading");
var _Header = _interopRequireDefault(require("../Header"));
var _SummaryHeader = _interopRequireDefault(require("../Header/SummaryHeader"));
var _Sidebar = _interopRequireDefault(require("../Sidebar"));
var _ApptSummary = _interopRequireDefault(require("../ApptSummary"));
var _OSWApptInfo = _interopRequireDefault(require("../OSWApptInfo"));
var _MobileAltProviders = _interopRequireDefault(require("../MobileAltProviders"));
var _styles = require("./styles");
var _useWindowWidth = _interopRequireDefault(require("../../lib/useWindowWidth"));
var _Tracking = require("../../lib/constants/Tracking");
var _historyRouting = require("../../hooks/history-routing");
var _thirdPartyLogin = require("../../lib/constants/thirdPartyLogin");
var _useThrottledResizeObserver = _interopRequireDefault(require("../../hooks/useThrottledResizeObserver"));
var _Filters = require("../../lib/constants/Filters");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*eslint-disable react/display-name */

/**
 *  Based on the current top level state we'll render a certain section in the app
 */
const renderersByState = [[_States.loadingProvider, _ref => {
  let {
    service,
    track
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Loading.LoadingProvider, {
    service: service,
    track: track
  });
}], [_States.apptInfo, _ref2 => {
  let {
    service,
    config,
    track,
    apptPurposeFilterProps
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_ApptInfo.default, {
    track: track,
    service: service,
    config: config,
    apptPurposeFilterProps: apptPurposeFilterProps
  });
}], [_States.apptTime, _ref3 => {
  let {
    service,
    config,
    mapApiKey,
    track,
    apptDensity,
    offsetTop,
    onScroll,
    awsMapConfig
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_ApptTime.default, {
    track: track,
    mapApiKey: mapApiKey,
    service: service,
    config: config,
    apptDensity: apptDensity,
    offsetTop: offsetTop,
    onScroll: onScroll,
    awsMapConfig: awsMapConfig
  });
}], [_States.patientInfo, _ref4 => {
  let {
    service,
    config,
    thirdPartyLoginProps,
    track
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_PatientInfo.default, {
    track: track,
    config: config,
    service: service,
    thirdPartyLoginProps: thirdPartyLoginProps
  });
}], [_States.reviewAppt, _ref5 => {
  let {
    service,
    track,
    config,
    bodyIsAnimating
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(_ReviewAppt.default, {
    service: service,
    track: track,
    config: config,
    bodyIsAnimating: bodyIsAnimating
  });
}], [_States.apptSummary, _ref6 => {
  let {
    service,
    mapApiKey,
    track,
    config,
    awsMapConfig
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(_ApptSummary.default, {
    service: service,
    mapApiKey: mapApiKey,
    track: track,
    config: config,
    awsMapConfig: awsMapConfig
  });
}], [_States.oswApptInfo, _ref7 => {
  let {
    service,
    config
  } = _ref7;
  return /*#__PURE__*/_react.default.createElement(_OSWApptInfo.default, {
    service: service,
    config: config
  });
}]];

// animation variants
// direction is used to determine if we slide left->right or right->left
const variants = {
  enter: direction => ({
    x: direction === -1 ? '-20%' : '20%',
    opacity: 0
  }),
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: direction => ({
    zIndex: 0,
    x: direction === -1 ? '20%' : '-20%',
    opacity: 0
  })
};

/**
 * @param {String} curStep
 * @returns {String}
 */
const getPageViewTracking = curStep => {
  const events = {
    [_States.apptInfo]: _Tracking.pageEvents.DBOOK_LANDING,
    [_States.apptTime]: _Tracking.pageEvents.PROVIDER_SCHEDULE,
    [_States.patientInfo]: _Tracking.pageEvents.PATIENT_REGISTRATION,
    [_States.reviewAppt]: _Tracking.pageEvents.CONFIRM_APPOINTMENT,
    [_States.apptSummary]: _Tracking.pageEvents.BOOKED_APPOINTMENT,
    [_States.oswApptInfo]: _Tracking.pageEvents.EPIC_OSW
  };
  return events[curStep];
};
const propTypes = {
  /* eslint-disable react/forbid-prop-types */
  config: _propTypes.object.isRequired,
  currentState: (0, _propTypes.instanceOf)(_xstate.State).isRequired,
  onGoBack: _propTypes.func.isRequired,
  track: _propTypes.func.isRequired,
  mapApiKey: _propTypes.string,
  awsMapConfig: _propTypes.object,
  thirdPartyLoginProps: (0, _propTypes.shape)({
    type: (0, _propTypes.oneOf)(['mychart']).isRequired,
    isLoggedIn: _propTypes.bool.isRequired,
    login: (0, _propTypes.shape)({
      url: _propTypes.string,
      callback: _propTypes.func.isRequired
    }).isRequired,
    logout: (0, _propTypes.shape)({
      url: _propTypes.string,
      callback: _propTypes.func.isRequired
    }).isRequired,
    errors: (0, _propTypes.arrayOf)((0, _propTypes.oneOf)((0, _values.default)(_thirdPartyLogin.ERROR)))
  }),
  /* optional react-router history object for db-widget to control url and forward/back */
  history: (0, _propTypes.shape)({
    push: _propTypes.func,
    replace: _propTypes.func,
    location: (0, _propTypes.shape)({
      pathname: _propTypes.string,
      search: _propTypes.string
    })
  }),
  apptDensity: (0, _propTypes.oneOf)(['default', 'dense']),
  /* Properties for the appointment purpose filter controls */
  apptPurposeFilterProps: (0, _propTypes.shape)({
    /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
    minPurposesForFilter: _propTypes.number,
    /* Labels for rendering the filter controls */
    labels: (0, _propTypes.shape)({
      noResultsLabel: _propTypes.string,
      purposeSearchLabel: _propTypes.string,
      purposeSearchPlaceholderLabel: _propTypes.string,
      visitTypeAllLabel: _propTypes.string,
      visitTypeInPersonLabel: _propTypes.string,
      visitTypeVirtualLabel: _propTypes.string
    }),
    /* Function executed when the name filter changes */
    onNameFilterChange: _propTypes.func,
    /* Function executed when the visit type filter changes */
    onVisitTypeFilterChange: _propTypes.func,
    /* Function executed when the filters are cleared */
    onClearFilters: _propTypes.func
  }),
  onScroll: _propTypes.func
};
const defaultProps = {
  mapApiKey: '',
  history: null,
  onScroll: () => window.scrollTo(0, 0)
};
function DirectBook(_ref8) {
  let {
    currentState,
    onGoBack,
    track,
    history,
    onScroll,
    config,
    ...props
  } = _ref8;
  const {
    ref: headerRef,
    height: headerHeight
  } = (0, _useThrottledResizeObserver.default)({});
  const [bodyIsAnimating, setBodyIsAnimating] = (0, _react.useState)(false);
  const {
    context
  } = currentState;
  const {
    provider,
    appointmentQuery,
    selectedAppointment,
    steps,
    curStep,
    stepsConfigurationType
  } = context;
  // direction handles the animation direction between steps
  const direction = (0, _react.useRef)(1);
  const {
    aboveMd
  } = (0, _useWindowWidth.default)();
  // throttle animating state to prevent animation states from infinitely flipping
  const setAnimating = (0, _lodash.default)(animating => {
    setBodyIsAnimating(animating);
  }, 350);
  const showSidebar = aboveMd && !currentState.matches(_States.apptSummary) && !currentState.matches(_States.loadingProvider) && !currentState.matches(_States.initializing) && !currentState.matches(_States.routing);
  const isOnAltProvidersStep = currentState.matches(_States.apptTime) && config.show_dbw_appt_time_alt_providers;
  const showMobileAltProviders = !aboveMd && isOnAltProvidersStep;
  const stepsConfiguration = _steps.default[stepsConfigurationType];
  const handleGoBack = stepStateKey => {
    if (!stepsConfiguration) {
      return null;
    }
    const curStepIndex = (0, _findIndex.default)(stepsConfiguration).call(stepsConfiguration, _ref9 => {
      let {
        stateKey
      } = _ref9;
      return stateKey === curStep;
    });
    const nextStepIndex = (0, _findIndex.default)(stepsConfiguration).call(stepsConfiguration, _ref10 => {
      let {
        stateKey
      } = _ref10;
      return stateKey === stepStateKey;
    });
    direction.current = curStepIndex === -1 || curStepIndex > nextStepIndex ? -1 : 1;
    if (!currentState.matches(stepStateKey)) {
      onGoBack(stepStateKey);
    }
  };
  (0, _historyRouting.useHistoryRouting)({
    currentState,
    history,
    handleGoBack,
    stepsConfiguration
  });
  const isApptSummary = currentState.matches(_States.apptSummary);

  // account for when a user scrolls to the bottom of the
  // appointment list, selects an apointment and goes to the next step
  (0, _react.useEffect)(() => {
    if (onScroll) {
      onScroll();
    }
    let patient_relationship;
    if (currentState?.context?.selectedAppointment?.purpose) {
      ({
        patient_relationship
      } = currentState?.context?.selectedAppointment?.purpose);
    }
    const pageViewTracking = getPageViewTracking(curStep);
    if (pageViewTracking) {
      if (patient_relationship) {
        track(pageViewTracking, {
          patient_relationship
        });
      } else {
        track(pageViewTracking);
      }
    }
    if (isApptSummary) {
      if (patient_relationship === _Filters.NEW_PATIENT) {
        track(_Tracking.userEvents.APPT_BOOKED_NEW_RELATIONSHIP);
      }
      if (patient_relationship === _Filters.ESTABLISHED_PATIENT) {
        track(_Tracking.userEvents.APPT_BOOKED_ESTABLISHED_RELATIONSHIP);
      }
    }
  }, [curStep, isApptSummary, track]); // ignore es-lint for this array, do not add currentState here or it breaks stuff :(

  const [, render] = (0, _find.default)(renderersByState).call(renderersByState, _ref11 => {
    let [state] = _ref11;
    return currentState.matches(state);
  }) || [];
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "DirectBook",
    className: "DirectBook"
  }, currentState.matches(_States.apptSummary) ? /*#__PURE__*/_react.default.createElement(_SummaryHeader.default, {
    track: track,
    currentState: currentState,
    config: config
  }) : /*#__PURE__*/_react.default.createElement(_Header.default, {
    ref: headerRef,
    onGoBack: handleGoBack,
    aboveMd: aboveMd,
    currentState: currentState,
    stepsConfiguration: stepsConfiguration
  }), /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, {
    custom: direction.current,
    exitBeforeEnter: true,
    initial: false
  }, /*#__PURE__*/_react.default.createElement(_styles.Body, {
    key: curStep,
    positionTransition: true,
    custom: direction.current,
    variants: variants,
    initial: "enter",
    animate: "center",
    exit: "exit",
    onAnimationComplete: () => {
      setAnimating(false);
      if (direction.current === -1) {
        direction.current = 1;
      }
    },
    onAnimationStart: () => {
      setAnimating(true);
    }
  }, render && /*#__PURE__*/_react.default.createElement(_styles.Content, {
    showSidebar: showSidebar
  }, render({
    ...props,
    bodyIsAnimating,
    config,
    onScroll,
    track,
    service: steps[curStep],
    ctx: context,
    offsetTop: headerHeight - 1
  })), showSidebar && /*#__PURE__*/_react.default.createElement(_Sidebar.default, {
    appointmentQuery: appointmentQuery,
    config: config,
    isOnAltProvidersStep: isOnAltProvidersStep,
    provider: provider,
    selectedAppointment: selectedAppointment,
    service: steps[curStep],
    track: track
  }),
  // desktop AltProviders code located in `packages/direct-book-widget/direct-book-widget/src/components/Sidebar/Sidebar.jsx`
  showMobileAltProviders && /*#__PURE__*/_react.default.createElement(_MobileAltProviders.default, {
    service: steps[curStep],
    config: config,
    track: track
  }))));
}
DirectBook.propTypes = propTypes;
DirectBook.defaultProps = defaultProps;
DirectBook.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DirectBook",
  "props": {
    "mapApiKey": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "history": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "push": {
            "name": "func",
            "required": false
          },
          "replace": {
            "name": "func",
            "required": false
          },
          "location": {
            "name": "shape",
            "value": {
              "pathname": {
                "name": "string",
                "required": false
              },
              "search": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false
    },
    "onScroll": {
      "defaultValue": {
        "value": "() => window.scrollTo(0, 0)",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "config": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "currentState": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "State"
      },
      "required": true
    },
    "onGoBack": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "awsMapConfig": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "thirdPartyLoginProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "type": {
            "name": "enum",
            "value": [{
              "value": "'mychart'",
              "computed": false
            }],
            "required": true
          },
          "isLoggedIn": {
            "name": "bool",
            "required": true
          },
          "login": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "required": false
              },
              "callback": {
                "name": "func",
                "required": true
              }
            },
            "required": true
          },
          "logout": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "required": false
              },
              "callback": {
                "name": "func",
                "required": true
              }
            },
            "required": true
          },
          "errors": {
            "name": "arrayOf",
            "value": {
              "name": "enum",
              "computed": true,
              "value": "Object.values(THIRD_PARTY_LOGIN_ERROR)"
            },
            "required": false
          }
        }
      },
      "required": false
    },
    "apptDensity": {
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'default'",
          "computed": false
        }, {
          "value": "'dense'",
          "computed": false
        }]
      },
      "required": false
    },
    "apptPurposeFilterProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "minPurposesForFilter": {
            "name": "number",
            "required": false
          },
          "labels": {
            "name": "shape",
            "value": {
              "noResultsLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchPlaceholderLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeAllLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeInPersonLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeVirtualLabel": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "onNameFilterChange": {
            "name": "func",
            "required": false
          },
          "onVisitTypeFilterChange": {
            "name": "func",
            "required": false
          },
          "onClearFilters": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": false
    }
  }
};